<template>
  <div>
    <v-alert v-model="alert" type="error">
      {{ informText }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="fbAccList"
      class="elevation-1"
      :loading="loading"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search..."
            single-line
            hide-details
            class="shrink mx-4"
          ></v-text-field>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <v-dialog
            v-model="dialog"
            max-width="700px"
            v-if="roles.read_baby_account"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                v-if="roles.create_baby_account"
                >Add Ads Account</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" v-if="informText != ''">
                      <v-alert type="error">
                        {{ informText }}
                      </v-alert>
                    </v-col>
                    <v-col cols="6">
                      <div v-if="editedIndex === -1">
                        <v-text-field
                          v-model="editedItem.account_id"
                          label="Account ID"
                          @keyup="validation"
                        ></v-text-field>
                      </div>
                      <div v-else>
                        <v-text-field
                          v-model="editedItem.account_id"
                          label="account_id"
                          disabled=""
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.vps"
                        label="VPS"
                        @keyup="validation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        type="number"
                        v-model="editedItem.limit"
                        label="Limit"
                        @keyup="validation"
                        @mouseup="validation"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="editedItem.note"
                        label="Note"
                        @keyup="validation"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="check">Check</v-btn> -->
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                  v-if="showBtn && roles.update_baby_account"
                  >Save</v-btn
                >
                <v-btn color="blue darken-1" text v-else disabled>Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn v-else class="mb-2" disabled>Add Ads Account</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.account_name="{ item }">
        <div>{{ item.account_name }}</div>
        <div>({{ item.account_id }})</div>
      </template>
      <template v-slot:item.bm_name="{ item }">
        <div>{{ item.bm_name }}</div>
        <div>({{ item.bm_id }})</div>
      </template>
      <template v-slot:item.pixels="{ item }">
        <div v-for="(i, index) of item.pixels" :key="index">
          + {{ i.name }} ({{ i.id }})
        </div>
      </template>
      <template v-slot:item.sharing_for="{ item }">
        <div v-for="(i, index) of item.sharing_for" :key="index">
          + {{ i.bm_name }} ({{ i.bm_id }})
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="primary"
          x-small
          @click="editItem(item)"
          v-if="roles.read_baby_account"
        >
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        <v-btn color="primary" x-small v-else disabled>
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
        &nbsp;
        <v-btn
          color="orange"
          x-small
          dark
          @click="deleteItem(item)"
          v-if="roles.delete_baby_account"
        >
          <v-icon small> mdi-delete </v-icon>
        </v-btn>
        <v-btn color="orange" x-small v-else disabled>
          <v-icon small> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "Sites",
  //new Vue({
  data: () => ({
    search: "",
    loading: true,
    dialog: false,
    dropdown: [],
    //re: [],
    //listUser: [],
    //platform: ["Shopify", "WooCommerce"],
    //AuthStr: "", //'Bearer '.concat(this.$cookies.get('token')),
    //user: {
    //   _id: "",
    //   name: "",
    // },
    headers: [
      { text: "BM Name", value: "bm_name", align: "start" },
      {
        text: "Account Name",
        value: "account_name",
      },
      { text: "Status", value: "status" },
      { text: "Disable Reason", value: "disable_reason" },
      { text: "Limit", value: "limit" },
      { text: "Payment", value: "payment" },
      { text: "Pixels", value: "pixels" },
      { text: "VPS", value: "vps" },
      { text: "Sharing", value: "sharing_for" },
      { text: "Note", value: "note" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    fbAccList: [],
    editedIndex: -1,
    editedItem: {
      account_id: "",
      vps: "",
      limit: 0,
      note: "",
    },
    defaultItem: {
      account_id: "",
      vps: "",
      limit: 0,
      note: "",
    },
    showBtn: null,
    userId: "",
    informText: "",
    alert: false,
    roles: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
      if (val == true && this.editedIndex != -1) {
        (this.showBtn = null), this.validation();
      } else {
        this.showBtn = null;
      }
    },
  },

  methods: {
    async loadData() {
      console.log("loadData");
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "fb-baby-list-saveData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        console.log("this.userId: ", this.userId);
        await axios
          .get(window.domain + "marketing/fb-ad-accounts", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);
            // If request is good...
            this.loading = false;
            this.fbAccList = response.data.data;
            if (response.data.error_message != "") {
              this.alert = true;
              this.informText = response.data.error_message;
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession fb-baby-list-loadData-undefined: ",
          currentSession
        );
      }
    },

    editItem(item) {
      this.editedIndex = this.fbAccList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.fbAccList.indexOf(item);
      var r =
        confirm("Are you sure you want to delete this item?") &&
        this.fbAccList.splice(index, 1);
      if (r != false) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "fb-baby-list-delete"
        );
        //console.log('currentSession: ',currentSession.accessToken)
        if (currentSession.accessToken) {
          axios
            .delete(
              window.domain + "marketing/fb-ad-accounts/" + item.account_id,
              {
                headers: { Authorization: currentSession.accessToken },
              }
            )
            .then((response) => JSON.stringify(response))
            .then((data) => console.log(data))
            .catch((error) => {
              console.log("Error:", error);
            });
        } else {
          console.log(
            "currentSession fb-baby-list-delete-undefined: ",
            currentSession
          );
        }
      }
    },

    close() {
      this.dialog = false;
      this.informText = "";
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    validation() {
      if (this.editedItem.account_id != "") {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    async save() {
      //this.editedItem.created_user_username = this.userId;
      //console.log(JSON.stringify(this.editedItem))

      var currentSession = await this.$root.$refs.App.currentSession(
        "fb-baby-list-saveData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        console.log("Edited Item: ", this.editedItem);
        if (this.editedIndex > -1) {
          var a = Object.assign(
            this.fbAccList[this.editedIndex],
            this.editedItem
          );
          await fetch(
            window.domain + "marketing/fb-ad-accounts/" + a.account_id,
            {
              method: "PUT",
              headers: { Authorization: currentSession.accessToken },
              body: JSON.stringify(this.editedItem),
            }
          )
            .then((response) => response.json())
            .then((data) => {
              console.log("edit fb-baby-list response: ", data);
              if (data.error_message == "") {
                this.close();
                this.informText = "";
                Object.assign(
                  this.fbAccList[this.editedIndex],
                  this.editedItem
                );
              } else {
                this.informText = data.error_message;
              }
            })
            .catch((error) => console.log(error));
        } else {
          await fetch(window.domain + "marketing/fb-ad-accounts", {
            method: "POST",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(this.editedItem),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("add fb-baby-list response: ", data);
              if (data.error_message == "") {
                this.close();
                this.informText = "";
                var item = data.data;
                this.fbAccList.push(item);
              } else {
                this.informText = data.error_message;
              }
            })
            .catch((error) => console.log("Err: ", error));
        }
        //this.close()
      } else {
        console.log(
          "currentSession fb-baby-list-saveData-undefined: ",
          currentSession
        );
      }
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },

    check() {
      console.log(this.editedItem);
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("fb_baby_account");
    if (this.roles.list_baby_accounts) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      var currentSession = await this.$root.$refs.App.currentSession(
        "fb-baby-list-saveData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        this.userId = currentSession.username;
      }

      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>
